import { BasePhaseModel } from './BasePhaseModel';
import { IPhase, PhaseType } from '../types';

export interface SitePlanPhaseData {
  attachments?: string[];
  comments?: string;
  siteVisitId?: string;
  sitePlanOrderId?: string;
}

export class SitePlanPhaseModel extends BasePhaseModel<SitePlanPhaseData> {
  constructor(phase: IPhase<SitePlanPhaseData>) {
    super(phase.type === PhaseType.SITE_PLAN ? phase : { ...phase, type: PhaseType.SITE_PLAN });
  }

  updateData(data: Partial<SitePlanPhaseData>): IPhase<SitePlanPhaseData> {
    return super.updateData({ ...(this.phase.data || {}), ...data });
  }

  attachDrawing(url: string): IPhase<SitePlanPhaseData> {
    const attachments = [...(this.phase.data?.attachments || []), url];
    return this.updateData({ attachments });
  }
}
